import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { BookingTypesStore } from '@fry/booking/lib';
import { BookingOption } from '@fry/booking/lib/booking-items/booking-option';
import { ListSearch } from '@fry/lib/list';


@Injectable()
export class BookingAvailableItemsSearch implements ListSearch {

  constructor(
    private bookingTypes: BookingTypesStore
  ) {}

  private fulltext() {
    return of({
      id: 'fulltext',
      label: '',
      filter: (item, value): Observable<boolean> => {
        return of(item.doc.title.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      },
      featured: true,
      widget: {
        type: 'string',
        placeholder: $localize `Full text search`,
      }
    });
  }

  private eligible() {
    return of({
      id: 'eligible',
      label: $localize `Show only items you are eligible for`,
      initial: true,
      widget: {
        type: 'boolean'
      },
      filter: (item: BookingOption, value): Observable<boolean> => {
        return of(value ? this.evaluateElibibilityForItem(item) : true);
      }
    });
  }

  private evaluateElibibilityForItem(item: BookingOption): boolean {
    const bookableType = item['bookableType'] !== undefined ? item['bookableType'] : item.orig['bookableType'];
    const isCover = bookableType === 'cover';
    const isBookable = bookableType === 'bookable';
    const isHidden = bookableType === 'hidden';
    const isBookingAllowed = item['bookingAllowed'] !== undefined ? item['bookingAllowed'] : item.doc['bookingAllowed'];

    // If item is hidden we should not show
    // - but that should be already filtered from store
    if (isHidden) {
      return false;
    }

    // If item is 'cover' we need to check if its 'options' are eligible and if
    // at least one is, include (return false), this needs to be done
    // recursivelly to leaf.
    if (isCover) {
      return item.doc.summary && item.doc.summary.eligible;
    }

    if (isBookable) {
      return isBookingAllowed;
    }

    return false;
  }

  private types() {
    return this.bookingTypes.all().pipe(
      map(types => {
        return {
          id: 'bookingTypes',
          label: $localize `Booking type`,
          widget: {
            type: 'multiSelect'
          },
          options: {
            categories: types.map(btype => {
              return { id: btype.doc._id, name: btype.doc.name };
            })
          },
          filter: (item, value): Observable<boolean> => {
            return of(value.indexOf(item.doc.bookingItem.bookingType) !== -1);
          }
        };
      })
    );
  }

  public filters() {
    return forkJoin([
      this.fulltext(),
      this.eligible(),
      this.types(),
    ]);
  }

  public sorts() {
    return of([
      {
        id: 'title',
        name: $localize `name`,
        sort: (itemA, itemB) => {
          return itemA.doc.title.toLowerCase() > itemB.doc.title.toLowerCase() ? 1 : -1;
        }
      }
    ]);
  }

}
